var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.live)?_c(_vm.dotOnly && !_vm.broadcasterID ? 'div' : _vm.SaLink,{tag:"component",staticClass:"bg-red shrink-0 text-white",class:_vm.dotOnly ? 'rounded-full w-1.5 h-1.5 !inline-block' : 'tag cursor-pointer',attrs:{"to":_vm.webcastUrl}},[_c('span',[_vm._v(_vm._s(_vm.dotOnly ? '' : _vm.$t('Live')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }